/* FAYARD CUSTOM. Retour en stock : bouton « Me prévenir » à la place du bouton épuisé, inscription Klaviyo. */
(function () {
  'use strict';

  var TEXT = {
    fr: { invalid: 'Merci de saisir une adresse courriel valide.', failed: 'Une erreur est survenue. Merci de réessayer.' },
    en: { invalid: 'Please enter a valid email address.', failed: 'Something went wrong. Please try again.' }
  };

  // Mémoire partagée avec le popup newsletter : on ne redemande pas une adresse déjà donnée.
  var EMAIL_KEY = 'fy-email';
  var BIS_KEY = 'fy-bis';
  var NL_KEY = 'fy-nl-state';

  function readJson(key) {
    try { return JSON.parse(localStorage.getItem(key) || '{}') || {}; } catch (e) { return {}; }
  }
  function writeJson(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }
  function validEmail(email) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email || ''); }

  // Adresse Klaviyo déjà identifiée sur ce navigateur (formulaire Klaviyo, clic dans un courriel…)
  function klaviyoEmail() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
      if (!m) return '';
      var data = JSON.parse(atob(decodeURIComponent(m[1])));
      return data.$email || '';
    } catch (e) { return ''; }
  }

  class FayardBackInStock extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      var self = this;
      // Si le navigateur nous démarre avant d'avoir lu notre contenu, on attend la fin du chargement
      if (!this.querySelector('[data-bis-open]') || !this.querySelector('[data-bis-modal]')) {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', function () { self.connectedCallback(); }, { once: true });
        } else {
          setTimeout(function () { if (self.isConnected) self.connectedCallback(); }, 50);
        }
        return;
      }
      this._ready = true;
      this.t = TEXT[this.dataset.locale === 'en' ? 'en' : 'fr'];
      this.form = this.closest('form') || this.parentElement.querySelector('form');
      this.productForm = this.closest('product-form') || this.parentElement;
      this.atc = null;
      this.modal = this.querySelector('[data-bis-modal]');
      // La fenêtre est déplacée dans <body> : un parent transformé (colonne collante) casserait position: fixed
      document.body.appendChild(this.modal);

      this.querySelector('[data-bis-open]').addEventListener('click', function () { self.open(); });
      this.modal.querySelectorAll('[data-bis-close]').forEach(function (el) {
        el.addEventListener('click', function () { self.close(); });
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !self.modal.hidden) self.close(); });
      this.modal.querySelector('[data-bis-submit]').addEventListener('click', function (e) { e.preventDefault(); self.send(); });
      this.modal.querySelector('[data-bis-email]').addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); self.send(); }
      });
      this.modal.querySelector('[data-bis-change]').addEventListener('click', function () { self.showKnown(false); });

      // Suit le bouton d'ajout au panier : désactivé = variante épuisée.
      // Le thème peut l'insérer un peu après nous : on revérifie quelques fois.
      document.addEventListener('variant:change', function () { setTimeout(function () { self.sync(); }, 0); });
      this.sync();
      [200, 600, 1500, 3000].forEach(function (ms) { setTimeout(function () { self.sync(); }, ms); });
      window.addEventListener('load', function () { self.sync(); });
    }

    watch() {
      var self = this;
      if (!this.atc || this.atc === this._watched) return;
      this._watched = this.atc;
      new MutationObserver(function () { self.sync(); }).observe(this.atc, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    }

    findAtc() {
      var scope = this.productForm;
      if (!scope) return null;
      // Le bouton du thème d'abord : une autre app (lots…) peut avoir un bouton submit plus haut dans le formulaire
      return scope.querySelector('buy-buttons button[type="submit"]') || scope.querySelector('button[type="submit"][name="add"]');
    }

    // Variante sélectionnée : celle que le formulaire enverrait (les champs liés par l'attribut form comptent,
    // le champ caché désactivé du thème est ignoré), puis l'URL, puis le champ caché par défaut.
    variantId() {
      if (this.form) {
        try { var v = new FormData(this.form).get('id'); if (v) return v; } catch (e) {}
      }
      var fromUrl = new URLSearchParams(location.search).get('variant');
      if (fromUrl) return fromUrl;
      var root = this.productForm || document;
      var input = root.querySelector('input[name="id"]');
      return input ? input.value : null;
    }

    sync() {
      if (!this.atc || !this.atc.isConnected) this.atc = this.findAtc();
      this.watch();
      var soldOut = !!(this.atc && (this.atc.disabled || this.atc.getAttribute('aria-disabled') === 'true'));
      this.hidden = !soldOut;
      if (this.atc) this.atc.classList.toggle('fy-bis-hidden', soldOut);
      var buyButtons = this.atc && this.atc.closest('buy-buttons');
      if (buyButtons) buyButtons.classList.toggle('fy-bis-soldout', soldOut);
      if (soldOut) this.updateLabel();
    }

    knownEmail() {
      var stored = (function () { try { return localStorage.getItem(EMAIL_KEY) || ''; } catch (e) { return ''; } })();
      var email = stored || this.dataset.customerEmail || klaviyoEmail();
      return validEmail(email) ? email : '';
    }

    isSubscribed() {
      return this.hasAttribute('data-customer-subscribed') || !!readJson(NL_KEY).subscribed;
    }

    alreadyAsked(variant) {
      return !!(variant && readJson(BIS_KEY)[variant]);
    }

    updateLabel() {
      var trigger = this.querySelector('[data-bis-open]');
      trigger.textContent = this.alreadyAsked(this.variantId()) ? this.dataset.labelDone : this.dataset.label;
    }

    // Adresse connue : on affiche « Nous écrirons à … » au lieu du champ
    showKnown(known) {
      var email = this.knownEmail();
      var on = known && !!email;
      var input = this.modal.querySelector('[data-bis-email]');
      this.modal.querySelector('[data-bis-known]').hidden = !on;
      this.modal.querySelector('[data-bis-known-email]').textContent = email;
      input.hidden = on;
      input.value = on ? email : (input.value || email);
      if (!on) setTimeout(function () { input.focus({ preventScroll: true }); input.select(); }, 50);
    }

    open() {
      var form = this.modal.querySelector('[data-bis-step="form"]');
      var success = this.modal.querySelector('[data-bis-step="success"]');
      var asked = this.alreadyAsked(this.variantId());
      // Alerte déjà demandée pour ce format : on le confirme simplement
      form.hidden = asked;
      success.hidden = !asked;
      this.showError('');
      var known = !!this.knownEmail();
      this.modal.querySelector('[data-bis-optin-row]').hidden = this.isSubscribed();
      this.modal.hidden = false;
      void this.modal.offsetWidth;
      this.modal.classList.add('is-open');
      if (asked) return;
      if (known) {
        this.showKnown(true);
        var submit = this.modal.querySelector('[data-bis-submit]');
        setTimeout(function () { submit.focus({ preventScroll: true }); }, 300);
      } else {
        this.modal.querySelector('[data-bis-known]').hidden = true;
        var email = this.modal.querySelector('[data-bis-email]');
        email.hidden = false;
        setTimeout(function () { email.focus({ preventScroll: true }); }, 300);
      }
    }

    close() {
      var modal = this.modal;
      modal.classList.remove('is-open');
      setTimeout(function () { modal.hidden = true; }, 300);
    }

    showError(message) {
      var error = this.modal.querySelector('[data-bis-error]');
      error.textContent = message;
      error.hidden = !message;
    }

    send() {
      var self = this;
      var emailInput = this.modal.querySelector('[data-bis-email]');
      var email = (emailInput.value || '').trim();
      var variant = this.variantId();
      if (!validEmail(email)) { this.showError(this.t.invalid); return; }
      if (!variant) { this.showError(this.t.failed); return; }
      this.showError('');
      var submit = this.modal.querySelector('[data-bis-submit]');
      submit.disabled = true;

      var base = 'https://a.klaviyo.com/client/';
      var query = '?company_id=' + encodeURIComponent(this.dataset.company);
      var headers = { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' };

      var requests = [fetch(base + 'back-in-stock-subscriptions/' + query, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant } } }
          }
        })
      })];

      // Case cochée : abonnement newsletter en plus (consentement explicite)
      var optin = !this.isSubscribed() && this.modal.querySelector('[data-bis-optin]').checked;
      if (optin) {
        requests.push(fetch(base + 'subscriptions/' + query, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Retour en stock (site)',
                profile: { data: { type: 'profile', attributes: { email: email } } }
              },
              relationships: { list: { data: { type: 'list', id: this.dataset.list } } }
            }
          })
        }));
      }

      Promise.all(requests).then(function (responses) {
        if (!responses[0].ok) throw new Error('HTTP ' + responses[0].status);
        try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (e) {}
        // On retient l'adresse et l'alerte : plus besoin de la ressaisir sur le prochain produit
        try { localStorage.setItem(EMAIL_KEY, email); } catch (e) {}
        var asked = readJson(BIS_KEY); asked[variant] = Date.now(); writeJson(BIS_KEY, asked);
        if (optin) { var nl = readJson(NL_KEY); nl.subscribed = Date.now(); writeJson(NL_KEY, nl); }
        self.updateLabel();
        self.modal.querySelector('[data-bis-step="form"]').hidden = true;
        self.modal.querySelector('[data-bis-step="success"]').hidden = false;
      }).catch(function () {
        self.showError(self.t.failed);
      }).finally(function () {
        submit.disabled = false;
      });
    }
  }

  if (!customElements.get('fayard-back-in-stock')) customElements.define('fayard-back-in-stock', FayardBackInStock);
})();
